//#region frontend/islands/native-share.js
var NativeShare = class extends HTMLElement {
	connectedCallback() {
		this._button = this.querySelector("button");
		this._shareTitle = this._button.getAttribute("data-title");
		this._shareText = this._button.getAttribute("data-text");
		this._shareUrl = this._button.getAttribute("data-url");
		this._handleShare = this._shareLink.bind(this);
		this._button.addEventListener("click", this._handleShare);
	}
	async _shareLink() {
		const shareData = {
			title: this._shareTitle,
			text: this._shareText,
			url: this._shareUrl
		};
		try {
			await navigator.share(shareData);
			console.log("MDN shared successfully");
		} catch (err) {
			console.error(`Error: ${err}`);
		}
	}
};
window.customElements.define("native-share", NativeShare);
//#endregion
